import { connect } from 'react-redux';

import EditMembernameModal from './EditMembernameModal';
import { submitMembername, resetMembername } from '../../actions/user';

function mapStateToProps({ user }) {
  return {
    isLoading: user.isUpdatingMembername,
    error: user.membernameUpdateError,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: memberName => dispatch(submitMembername(memberName)),
    onReset: () => dispatch(resetMembername()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMembernameModal);
export { default as USERNAME_STATE } from './EditMembernameModal';
